// extracted by mini-css-extract-plugin
export default {"GridHistorySection":"ProfileGridSection_GridHistorySection__xvcsd"};